<template>
  <!-- //ALEXMODI -->
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <core-table :config="config" title="Sites" upsert-max-width="650px">

          <template slot='headerActions'>
            <slot name='headerActions' />


            <v-badge v-if="$can('upsert', 'site')" style="margin-right:30px" color="pink"
              :content="counters['SafetyDB']" overlap>
              <v-chip @click="sync('SafetyDB')">SafetyDB</v-chip>
            </v-badge>

            <v-badge v-if="$can('upsert', 'site')" style="margin-right:30px" color="pink" :content="counters['eCDS']"
              overlap>
              <v-chip @click="sync('eCDS')">eCDS</v-chip>
            </v-badge>


            <v-badge v-if="$can('upsert', 'site')" style="margin-right:40px" color="pink"
              :content="counters['EMN Logistic']" overlap>
              <v-chip @click="sync('EMN Logistic')">EMN Logistic</v-chip>
            </v-badge>


            <v-badge v-if="$can('upsert', 'site')" style="margin-right:40px" color="pink" :content="counters['eTMF']"
              overlap>
              <v-chip @click="sync('eTMF')">eTMF</v-chip>
            </v-badge>


            <!-- issue 217 -->
            <!--
            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" v-if="$can('import', 'site')" color="secondary" @click="pickFile"
                  :loading="loadingUpload">
                  <v-icon>mdi-upload</v-icon>
                </v-btn>
              </template>
              <span>Import CSV/XLSX</span>
            </v-tooltip>
            -->
            <!-- issue 217 -->

            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" :loading="loadingExport['excel']" v-if="$can('export', 'site')" color="secondary"
                  @click="export_excel()">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Export Excel</span>
            </v-tooltip>

            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" :loading="loadingExport['csv']" v-if="$can('export', 'site')" color="secondary"
                  @click="export_csv()">
                  <v-icon>mdi-file-delimited</v-icon>
                </v-btn>
              </template>
              <span>Export CSV</span>
            </v-tooltip>
          </template>

        </core-table>

      </v-flex>
    </v-layout>

    <input id="file" ref="file" type="file" style="display: none" accept=".xls, .xlsx, .csv"
      @change="handleFileUpload()" />

  </v-container>
</template>

<script>
import XLSX from "xlsx"
import config from './config_index.js'
import { export_data } from '@/api/export.js'
import { upsert, get, post } from '@/api/base_entity'

export default {
  data() {
    return {
      config,
      loadingExport: { 'csv': false, 'excel': false },
      loadingUpload: false,
      counters: {},
      filters: {}
    }
  },
  mounted() {
    this.loadCounters()
  },
  methods: {
    async sync(platform) {

      const ret = await this.$root.$confirm.open('Confirm Sync Platform', 'Are you sure you want to sync the sites for platform ' + platform + ' ?', { color: 'red' })
      if (!ret) {
        return
      }

      this.counters[platform] = '...'

      post('/sync_platforms/site', { platform }).then(() => {
        this.$root.$emit('openSnackbar', {
          message: platform + ' synced correctly',
          color: 'success'
        })
      }).finally(() => {
        this.loadCounters()
      })

    },
    loadCounters() {
      get('/site_counters').then(ret => {
        this.counters = ret
      })
    },
    export_csv() {
      this.loadingExport['csv'] = true
      export_data('site').then(() => {
        this.loadingExport['csv'] = false
      })
    },
    export_excel() {
      this.loadingExport['excel'] = true
      export_data('site', 'excel').then(() => {
        this.loadingExport['excel'] = false
      })
    },
    pickFile() {
      this.$refs.file.click();
    },
    handleFileUpload() {
      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.$store.dispatch("app/startLoading");
      const reader = new FileReader();
      reader.onload = this.processExcel;
      reader.readAsBinaryString(file);
      this.loadingUpload = true
    },
    processExcel(e) {

      setTimeout(() => { // questo per rendere il blocco async
        const data = e.target.result;

        // Questa fottuta è bloccante
        const wb = XLSX.read(data, { type: "binary", cellDates: true });
        const first_sheet = wb.SheetNames[0];

        // Override Date obj toJSON to format date (YYYY-MM-DD)
        Date.prototype.toJSON = function () {

          var month = '' + (this.getMonth() + 1),
            day = '' + this.getDate(),
            year = this.getFullYear();

          if (month.length < 2) {
            month = '0' + month;
          }

          if (day.length < 2) {
            day = '0' + day;
          }

          return [year, month, day].join('-');
        };

        // Check !ref 
        delete wb.Sheets[first_sheet]['!margins'];
        const ref = wb.Sheets[first_sheet]['!ref'];
        delete wb.Sheets[first_sheet]['!ref'];

        const refEl = ref.split(':');
        // const refLatestRow = refEl[1].match(/(\d+)/)[0]; 
        const refLatestCol = refEl[1].replace(/[0-9]/g, '');

        const sheetKeys = Object.keys(wb.Sheets[first_sheet]);
        let maxRow = 0;

        sheetKeys.map(el => {
          if (el[0] == '!') {
            return;
          }
          try {
            var n = parseInt(el.match(/(\d+)/)[0]);
            maxRow = maxRow < n ? n : maxRow;
          } catch (e) {
            console.error(e, el)
          }
        });

        const newRef = refEl[0] + ':' + refLatestCol + maxRow;

        wb.Sheets[first_sheet]['!ref'] = ref;

        if (newRef != ref) {
          /* 
          const message = 'This excel appears to be corrupt, SafetyDB has fix it, please check the data integrity!';
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "error"
          });
          */
          //console.log('New !REF', newRef);
          wb.Sheets[first_sheet]['!ref'] = newRef;
        }

        if (sheetKeys.length > 2000000) {
          const message = "Spreadsheet is too long! Pleae verify the empty rows.";
          // this.$store.dispatch("app/openAlert", {message});
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "error"
          });
          this.$store.dispatch("app/stopLoading");
          return;
        }

        const rows = XLSX.utils.sheet_to_json(wb.Sheets[first_sheet], {
          header: 1,
          blankRows: false,
          defval: "",
        });

        if (!rows.length) {
          const message = "Spreadsheet is empty!";
          // this.$store.dispatch("app/openAlert", {message});
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "error"
          });
          this.$store.dispatch("app/stopLoading");
          return
        }

        upsert('import_sites', { rows }).then(() => {
          this.$refs.dataTable.getData();
        }).finally(() => {
          this.$store.dispatch("app/stopLoading");
          this.loadingUpload = false
        })

        this.$refs.file.value = '';

      }, 50);

      // this.loading = false;
      // this.$store.dispatch("app/stopLoading");
      //this.initDataset(rows);
    }
  }
}
</script>